import React, { useEffect } from 'react';
import { AlertUtils } from '@cyberint/common-alerts';
import { apiClient, API_PATHS, isDigitsOnly } from '@cyberint/common-utils';
import { useRouteTitle } from '../../hooks/useRouteTitle';
import { t } from '../../i18n';

const { BY_ID, BY_REF_ID } = API_PATHS.ALERT_API_PATHS;

const fetchAlertById = async ({ alertId, region }) => {
  const path = isDigitsOnly(alertId) ? BY_ID(alertId) : BY_REF_ID(alertId);
  const { data } = await apiClient.createAlertClient(region).post(path, {});
  return data.data?.alert;
};

export const AlertTitle = ({ match, region }) => {
  const alertId = match?.params?.id;
  const { title, setTitle } = useRouteTitle(match);

  useEffect(() => {
    if (title || !alertId) return;
    const isRefId = Number.isNaN(Number(alertId));
    if (isRefId) {
      setTitle(`${t('action-types.alert')}: ${alertId}`);
      return;
    }
    fetchAlertById({ alertId, region }).then(alert => {
      const computedTitle = alert && (alert.ref_id || alert.draft_id || AlertUtils.getAlertTitle(alert));
      if (computedTitle) setTitle(`${t('action-types.alert')}: ${computedTitle}`);
    });
  }, [alertId]);

  return <span>{title || `${t('action-types.alert')}: ${alertId ?? '...'}`}</span>;
};
